import { Header } from "@/components/global/header/Header";
import { Footer } from "@/components/global/footer/Footer";
import { DateChecker } from "./DateChecker";

export const DatePage = (): JSX.Element => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <DateChecker />
      </main>
      <Footer />
    </div>
  );
}; 